/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_TakeoverInputs */

const en_footer_risks_takeover = /** @type {(inputs: Footer_Risks_TakeoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI takeover`)
};

/**
* | output |
* | --- |
* | "AI takeover" |
*
* @param {Footer_Risks_TakeoverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_takeover = /** @type {((inputs?: Footer_Risks_TakeoverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_TakeoverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_takeover(inputs)
});